/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* Card quantity controls only. Purchases use the existing theme handler. */
(function () {
  if (window.scCardQuantityInstalled) return;
  window.scCardQuantityInstalled = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sc-quantity-step]');
    if (!button) return;
    var group = button.closest('.sc-card-quantity');
    if (!group) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var input = group.querySelector('[data-sc-card-quantity]');
    input.setCustomValidity('');
    if (Number(input.max) < Number(input.min) && input.max !== '') {
      input.reportValidity();
      return;
    }
    if (input.value === '' || !Number.isSafeInteger(Number(input.value))) input.value = input.min || '1';
    else if (button.getAttribute('data-sc-quantity-step') === '1') input.stepUp();
    else input.stepDown();
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-sc-card-quantity]')) event.target.setCustomValidity('');
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.isComposing || !event.target.matches('[data-sc-card-quantity]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = event.target.closest('form');
    var button = form && form.querySelector('[data-action="add-to-cart"]');
    if (button && !button.disabled) button.click();
  }, true);
})();

/* Collection navigation only: no product-query or CloudSearch parameters. */
(function () {
  if (customElements.get('sc-collection-navigation')) return;
  class CollectionNavigation extends HTMLElement {
    connectedCallback() {
      if (this._listeners) return;
      this._listeners = new AbortController();
      this._loadVersion = 0;
      this._toggle = this.querySelector('.sc-collection-navigation__toggle');
      this._panel = this.querySelector('.sc-collection-navigation__panel');
      this._find = this.querySelector('.sc-collection-navigation__find');
      this._list = this.querySelector('.sc-collection-navigation__list');
      this._status = this.querySelector('.sc-collection-navigation__status');
      if (!this._toggle || !this._panel || !this._find || !this._list || !this._status) return;
      var options = { signal: this._listeners.signal };
      this._toggle.addEventListener('click', () => {
        if (this._panel.hidden) this._open();
        else this._close(false);
      }, options);
      this._find.addEventListener('input', () => this._filter(), options);
      this.addEventListener('keydown', (event) => this._key(event), options);
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this._close(false);
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this._close(false);
      }, options);
    }
    disconnectedCallback() {
      if (this._request) this._request.abort();
      if (this._listeners) this._listeners.abort();
      this._listeners = null;
      this._loadVersion++;
    }
    _close(returnFocus) {
      if (!this._panel || this._panel.hidden) return;
      this._panel.hidden = true;
      this._toggle.setAttribute('aria-expanded', 'false');
      this._panel.removeAttribute('aria-busy');
      this._loadVersion++;
      if (this._request) this._request.abort();
      if (returnFocus) this._toggle.focus();
    }
    async _open() {
      this._panel.hidden = false;
      this._toggle.setAttribute('aria-expanded', 'true');
      this._find.value = '';
      this._loaded = false;
      this._list.replaceChildren();
      this._status.textContent = 'Loading collections…';
      this._panel.setAttribute('aria-busy', 'true');
      this._find.focus();
      if (this._request) this._request.abort();
      this._request = new AbortController();
      var version = ++this._loadVersion;
      try {
        var links = await this._loadAll(this._request.signal);
        if (version !== this._loadVersion || this._panel.hidden) return;
        var fragment = document.createDocumentFragment();
        links.forEach((item) => {
          var link = document.createElement('a');
          link.className = 'sc-collection-navigation__link';
          link.href = item.url;
          link.textContent = item.title;
          fragment.appendChild(link);
        });
        this._list.replaceChildren(fragment);
        this._loaded = true;
        this._panel.removeAttribute('aria-busy');
        this._filter();
      } catch (error) {
        if (version !== this._loadVersion || error.name === 'AbortError') return;
        this._list.replaceChildren();
        this._panel.removeAttribute('aria-busy');
        this._status.textContent = 'Collections could not be loaded. Close and reopen to retry.';
      }
    }
    async _loadAll(signal) {
      var next = new URL(this.dataset.source, window.location.origin);
      var seenPages = new Set();
      var items = new Map();
      var expectedPage = 1;
      while (next) {
        if (next.origin !== window.location.origin) throw new Error('Invalid collection data URL.');
        next.searchParams.set('section_id', 'sc-header-collections');
        if (seenPages.has(next.href)) throw new Error('Repeated collection data page.');
        seenPages.add(next.href);
        var response = await fetch(next.href, {
          credentials: 'same-origin', cache: 'no-store', signal: signal,
          headers: { 'Accept': 'text/html' }
        });
        if (!response.ok) throw new Error('Collection data request failed.');
        var html = await response.text();
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var page = parsed.querySelector('[data-sc-collection-page]');
        if (!page) throw new Error('Collection data section is missing.');
        var current = Number(page.dataset.page);
        var pages = Number(page.dataset.pages);
        if (current !== expectedPage || !Number.isSafeInteger(pages) || pages < current) throw new Error('Incomplete collection pagination.');
        page.querySelectorAll('a[data-sc-collection-id]').forEach((link) => {
          var id = link.getAttribute('data-sc-collection-id');
          var href = link.getAttribute('href');
          if (!id || !href) throw new Error('Incomplete collection link.');
          var url = new URL(href, window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('Invalid collection link.');
          items.set(id, { title: link.textContent, url: url.pathname + url.search + url.hash });
        });
        if (current < pages && !page.dataset.next) throw new Error('Missing next collection page.');
        if (current === pages && page.dataset.next) throw new Error('Unexpected collection pagination.');
        next = page.dataset.next ? new URL(page.dataset.next, next) : null;
        expectedPage++;
      }
      var collator = new Intl.Collator(document.documentElement.lang || 'en', { sensitivity: 'base' });
      return Array.from(items.values()).sort((a, b) => collator.compare(a.title, b.title));
    }
    _filter() {
      if (!this._loaded) return;
      var normalize = (value) => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      var query = normalize(this._find.value.trim());
      var count = 0;
      this._list.querySelectorAll('a').forEach((link) => {
        link.hidden = !normalize(link.textContent).includes(query);
        if (!link.hidden) count++;
      });
      if (this._panel.hasAttribute('aria-busy')) return;
      this._status.textContent = count ? count + (count === 1 ? ' collection' : ' collections') : 'No matching collections.';
    }
    _key(event) {
      if (event.isComposing) return;
      if (event.key === 'Escape' && !this._panel.hidden) {
        event.preventDefault();
        event.stopPropagation();
        this._close(true);
        return;
      }
      if (event.target === this._toggle && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        if (this._panel.hidden) this._open();
        else this._find.focus();
        return;
      }
      if (event.target === this._find && event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      var links = Array.from(this._list.querySelectorAll('a')).filter((link) => !link.hidden);
      var index = links.indexOf(event.target);
      if (event.target === this._find && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        if (links.length) links[event.key === 'ArrowDown' ? 0 : links.length - 1].focus();
      } else if (index !== -1 && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.key === 'Home') links[0].focus();
        else if (event.key === 'End') links[links.length - 1].focus();
        else if (event.key === 'ArrowUp' && index === 0) this._find.focus();
        else links[(index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      }
    }
  }
  customElements.define('sc-collection-navigation', CollectionNavigation);
})();

/* Verified savings display. Reads approved records; never rewrites selling prices.
 * Accepts the existing pilot payload during the one-file-at-a-time migration.
 */
(function () {
  'use strict';
  const controllers = new WeakMap();
  const normalize = value => String(value).replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  // Presentation only: exactly 70% passes; compare integer cents before rounding.
  function comparisonWithinLimit(price, reference) {
    if (!Number.isSafeInteger(price) || !Number.isSafeInteger(reference) || price < 0 || reference <= price) return false;
    if (typeof BigInt !== 'function') return false;
    return BigInt(price) * BigInt(10) >= BigInt(reference) * BigInt(3);
  }
  // Reusable read-only predicate for existing theme display controllers.
  window.scSavingsComparisonAllowed = comparisonWithinLimit;
  function start(configNode) {
    if (controllers.has(configNode)) return;
    const form = configNode.closest('form.product-form');
    const root = configNode.closest('[data-section-type="product"]');
    if (!form || !root) return;
    let payload, productData, currentVariant;
    try {
      payload = JSON.parse(configNode.textContent);
      productData = JSON.parse(root.querySelector('[data-product-json]').textContent);
      currentVariant = productData.product.variants.find(variant => String(variant.id) === String(productData.selected_variant_id));
    } catch (_) { return; }
    const isManifest = Array.isArray(payload.records);
    if (isManifest) {
      root.classList.add('sc-wcg-pilot');
      if (payload.schemaVersion !== 1 || payload.enabled !== true || payload.currency !== 'CAD' || payload.displayCurrency !== payload.currency) return;
    } else {
      // Backward compatibility only: retain every existing controlled-pilot gate.
      if (payload.variantId !== '52954860290358' || payload.sku !== 'WCG-G604MB') return;
      if (payload.price !== 2500 || payload.reference !== 4999 || payload.currency !== 'CAD') return;
      if (payload.enabled !== true || payload.referenceVerified !== true || payload.customerPriceTested !== true) return;
      if (!['supplier_compare_at', 'former_wholesale', 'msrp'].includes(payload.referenceBasis)) return;
      if (!payload.referenceLabel || !payload.supplierEvidence || payload.sellingUnitConfirmed !== true) return;
    }
    function selectedConfig() {
      if (!currentVariant) return null;
      const config = isManifest ? payload.records.find(record => record.variantId === String(currentVariant.id)) : payload;
      if (!config || config.variantId !== String(currentVariant.id) || config.sku !== currentVariant.sku) return null;
      if (!Number.isSafeInteger(config.price) || !Number.isSafeInteger(config.reference) || config.price < 0 || config.reference <= config.price) return null;
      if (currentVariant.price !== config.price || currentVariant.compare_at_price !== config.reference) return null;
      if (!comparisonWithinLimit(config.price, config.reference)) return null;
      if (isManifest) {
        if (config.verified !== true || config.currency !== payload.currency || config.evidenceConfirmed !== true) return null;
        if (typeof config.sellingUnit !== 'string' || !config.sellingUnit.trim()) return null;
        if (!Number.isSafeInteger(config.packQuantity) || config.packQuantity < 1) return null;
        if (!['supplier_compare_at', 'former_wholesale', 'msrp'].includes(config.referenceBasis)) return null;
        // No arbitrary expiry. Enforce one only when the evidence supplies it.
        if (config.expiresAt != null && config.expiresAt !== '') {
          if (typeof config.expiresAt !== 'string' || !/T.*(?:Z|[+-]\d{2}:\d{2})$/.test(config.expiresAt)) return null;
          const expiry = Date.parse(config.expiresAt);
          if (!Number.isFinite(expiry) || Date.now() >= expiry) return null;
        }
      }
      if (typeof config.priceText !== 'string' || typeof config.referenceText !== 'string' || !config.priceText || !config.referenceText) return null;
      if (typeof config.referenceLabel !== 'string' || !config.referenceLabel) return null;
      if (typeof config.saveText !== 'string' || !config.saveText.includes('__PERCENT__')) return null;
      return config;
    }
    const observer = new MutationObserver(paint);
    let paintFrame = 0;
    let expiryTimer = 0;
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
      cancelAnimationFrame(paintFrame);
      paintFrame = requestAnimationFrame(paint);
    }) : null;
    if (resizeObserver) resizeObserver.observe(form);
    function observe() {
      observer.observe(form, {subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['class', 'style', 'hidden']});
    }
    function paint() {
      observer.disconnect();
      clearTimeout(expiryTimer);
      try {
        if (!configNode.isConnected || !form.isConnected) return;
        root.classList.add('sc-wcg-pilot');
        form.querySelectorAll('[data-sc-wcg-owned]').forEach(node => node.remove());
        const list = form.querySelector('.price-list');
        if (!list) return;
        list.classList.remove('sc-wcg-price-row');
        const config = selectedConfig();
        if (!config) return;
        if (isManifest && config.expiresAt) {
          expiryTimer = setTimeout(paint, Math.min(Date.parse(config.expiresAt) - Date.now(), 2147483647));
        }
        const visible = Array.from(list.querySelectorAll('.price:not(.price--compare)'))
          .filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
        if (visible.length !== 1) return;
        const clone = visible[0].cloneNode(true);
        clone.querySelectorAll('.visually-hidden').forEach(node => node.remove());
        // Existing BMT safeguard: unfamiliar or changed visible prices fail closed.
        if (normalize(clone.textContent) !== normalize(config.priceText)) return;
        const percent = (config.reference - config.price) * 100 / config.reference;
        if (!Number.isFinite(percent) || percent <= 0) return;
        // Round presentation only, after the exact unrounded eligibility check.
        const percentText = Math.round(percent) + '%';
        const reference = document.createElement('del');
        reference.className = 'sc-wcg-reference';
        reference.setAttribute('data-sc-wcg-owned', 'reference');
        reference.setAttribute('aria-label', config.referenceLabel + ': ' + config.referenceText);
        reference.textContent = config.referenceText;
        const badge = document.createElement('span');
        badge.className = 'sc-wcg-saving';
        badge.setAttribute('data-sc-wcg-owned', 'badge');
        badge.textContent = config.saveText.replace('__PERCENT__', percentText);
        list.classList.add('sc-wcg-price-row');
        list.prepend(reference);
        list.append(badge);
      } finally {
        if (configNode.isConnected && form.isConnected) observe();
      }
    }
    function onVariant(event) {
      if (event.target !== root && !form.contains(event.target)) return;
      currentVariant = event.detail && event.detail.variant || null;
      paint();
    }
    root.addEventListener('variant:changed', onVariant);
    controllers.set(configNode, {stop() {
      observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      cancelAnimationFrame(paintFrame);
      clearTimeout(expiryTimer);
      root.removeEventListener('variant:changed', onVariant);
    }});
    paint();
  }
  function visit(node) {
    if (node.nodeType !== 1) return;
    if (node.matches('script[data-sc-wcg-pilot]')) start(node);
    node.querySelectorAll('script[data-sc-wcg-pilot]').forEach(start);
  }
  function stopRemoved(node) {
    if (node.nodeType !== 1) return;
    const nodes = node.matches('script[data-sc-wcg-pilot]') ? [node] : [];
    nodes.push(...node.querySelectorAll('script[data-sc-wcg-pilot]'));
    nodes.forEach(config => {
      const controller = controllers.get(config);
      if (controller && !config.isConnected) {
        controller.stop();
        controllers.delete(config);
      }
    });
  }
  visit(document.documentElement);
  // Quick View inserts HTML dynamically; the loaded controller handles it.
  new MutationObserver(records => records.forEach(record => {
    record.removedNodes.forEach(stopRemoved);
    record.addedNodes.forEach(visit);
  })).observe(document.body, {childList: true, subtree: true});
})();

/* WCG Cypress only: keep the old product-meta sale badge suppressed.
 * This safety guard is intentionally active while the NEW savings pilot is off.
 * It changes no prices, customer permissions, cards, cart or global settings.
 */
(function () {
  'use strict';
  if (window.scWcgLegacyBadgeGuardInstalled) return;
  window.scWcgLegacyBadgeGuardInstalled = true;
  const productId = '10326657171766';
  const variantId = '52954860290358';
  const styleId = 'sc-wcg-legacy-badge-guard-style';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = '[data-sc-wcg-legacy-guard] .product-meta .product-label--on-sale { display: none !important; }';
    document.head.appendChild(style);
  }
  function mark(script) {
    const section = script.closest('[data-section-type="product"]');
    if (!section || !section.isConnected) return;
    const key = String(section.getAttribute('data-section-id') || '').split('__').pop();
    if (key !== 'main') return;
    let data;
    try { data = JSON.parse(script.textContent); } catch (_) { return; }
    const product = data && data.product;
    if (!product || String(product.id) !== productId || !Array.isArray(product.variants)) return;
    const pilotVariant = product.variants.find(variant => String(variant.id) === variantId);
    if (!pilotVariant || pilotVariant.sku !== 'WCG-G604MB') return;
    section.setAttribute('data-sc-wcg-legacy-guard', '');
  }
  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches('script[data-product-json]')) mark(node);
    node.querySelectorAll('script[data-product-json]').forEach(mark);
  }
  scan(document.documentElement);
  // Quick View inserts HTML dynamically; no inline script execution is required.
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(scan));
  }).observe(document.body, {childList: true, subtree: true});
  // Defensive fallback at the same variant lifecycle used by the existing theme.
  document.addEventListener('variant:changed', event => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const section = target.closest('[data-section-type="product"]');
    if (section) section.querySelectorAll('script[data-product-json]').forEach(mark);
  });
})();

/* Product and Quick View quantity feedback only. Existing quantity handlers stay in charge. */
(function () {
  'use strict';
  if (window.scQuantityFeedbackInstalled) return;
  window.scQuantityFeedbackInstalled = true;
  const selector = '.sc-refined-product-info .product-form .quantity-selector--product';
  const buttonSelector = ':is(#main, body) ' + selector + ' > button.quantity-selector__button';
  const enabled = ':not(:disabled):not([aria-disabled="true"])';
  const style = document.createElement('style');
  style.id = 'sc-quantity-feedback-style';
  style.textContent = `
    ${buttonSelector} {
      background-color: #fff;
      color: var(--secondary-button-background, #f47721);
      box-shadow: inset 0 0 0 1px rgba(244,119,33,.30);
      transition: background-color 180ms cubic-bezier(.16,1,.3,1), box-shadow 180ms cubic-bezier(.16,1,.3,1), transform 180ms cubic-bezier(.16,1,.3,1);
      transform: none;
    }
    @media (hover: hover) and (pointer: fine) {
      ${buttonSelector}${enabled}:hover {
        background-color: var(--secondary-button-background, #f47721);
        color: #fff;
        box-shadow: inset 0 0 0 1px var(--secondary-button-background, #f47721), 0 3px 9px rgba(244,119,33,.24);
        transform: translateY(-1px);
      }
    }
    ${buttonSelector}${enabled}:active {
      background-color: var(--secondary-button-background, #f47721);
      color: #fff;
      box-shadow: inset 0 0 0 1px var(--secondary-button-background, #f47721), 0 1px 4px rgba(244,119,33,.20);
      transform: translateY(1px) scale(.96);
      transition-duration: 150ms;
    }
    ${buttonSelector}${enabled}:focus-visible {
      outline: 2px solid #a94700;
      outline-offset: 2px;
    }
    ${buttonSelector}:disabled,
    ${buttonSelector}[aria-disabled="true"] {
      background-color: #f3f3f3;
      color: #999;
      opacity: .45;
      box-shadow: none;
      transform: none;
      transition: none;
      cursor: not-allowed;
    }
    @media (prefers-reduced-motion: reduce) {
      ${buttonSelector} {
        transition: none !important;
        transform: none !important;
      }
    }
  `;
  document.head.appendChild(style);
  const ownedDisabled = new WeakSet();
  let frame = 0;
  function reflectBoundary(button, atBoundary) {
    if (!button) return;
    if (atBoundary && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
      ownedDisabled.add(button);
      button.disabled = true;
    } else if (!atBoundary && ownedDisabled.has(button)) {
      ownedDisabled.delete(button);
      button.disabled = false;
    }
  }
  function sync() {
    frame = 0;
    document.querySelectorAll(selector).forEach(group => {
      const input = group.querySelector('input.quantity-selector__value');
      if (!input) return;
      const value = Number(input.value);
      const min = input.hasAttribute('min') && input.min !== '' ? Number(input.min) : 1;
      const max = input.hasAttribute('max') && input.max !== '' ? Number(input.max) : Infinity;
      if (!Number.isFinite(value) || input.value.trim() === '') return;
      reflectBoundary(group.querySelector('[data-action="decrease-picker-quantity"]'), value <= min);
      reflectBoundary(group.querySelector('[data-action="increase-picker-quantity"]'), Number.isFinite(max) && value >= max);
    });
  }
  function queue() {
    if (!frame) frame = requestAnimationFrame(sync);
  }
  document.addEventListener('input', event => {
    if (event.target.matches(selector + ' input.quantity-selector__value')) queue();
  });
  document.addEventListener('change', event => {
    if (event.target.matches(selector + ' input.quantity-selector__value')) queue();
  });
  document.addEventListener('click', event => {
    if (event.target.closest(selector + ' .quantity-selector__button')) queue();
  });
  document.addEventListener('variant:changed', queue);
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' ||
      (record.target.matches && record.target.matches(selector + ' input, ' + selector + ' button')))) queue();
  });
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['min', 'max', 'value', 'disabled', 'aria-disabled']
  });
  queue();
})();

/* PhotoSwipe arrows: presentation only; existing navigation remains in charge. */
(function () {
  'use strict';
  const style = document.createElement('style');
  style.id = 'sc-orange-lightbox-arrows-style';
  const arrow = '.sc-modern-viewer .pswp__prev-next > button.pswp__button';
  const enabled = ':not(:disabled):not([aria-disabled="true"])';
  style.textContent = `
    ${arrow} {
      background: #fff !important;
      color: var(--accent-color, #f47721) !important;
      border: 2px solid var(--secondary-button-background, #f47721) !important;
      border-radius: 50%;
      box-shadow: none;
      scale: 1;
      translate: 0 0;
      transition: background-color 180ms ease-out, color 180ms ease-out,
        box-shadow 180ms ease-out, scale 160ms ease-out, translate 160ms ease-out;
    }
    ${arrow} svg { color: inherit !important; }
    ${arrow} svg path { stroke: currentColor; stroke-width: 2.5; }
    @media (hover: hover) and (pointer: fine) {
      ${arrow}${enabled}:hover {
        background: var(--secondary-button-background, #f47721) !important;
        color: #fff !important;
        box-shadow: 0 4px 14px rgba(244,119,33,.28);
        scale: 1;
        translate: 0 -2px;
      }
    }
    ${arrow}${enabled}:active {
      background: var(--secondary-button-background, #f47721) !important;
      color: #fff !important;
      box-shadow: 0 1px 4px rgba(244,119,33,.20);
      scale: .96;
      translate: 0 1px;
      transition-duration: 160ms;
    }
    ${arrow}:focus-visible {
      outline: 3px solid var(--secondary-button-background, #f47721);
      outline-offset: 3px;
    }
    ${arrow}:disabled,
    ${arrow}[aria-disabled="true"] {
      background: #f3f3f3 !important;
      color: #999 !important;
      border-color: #bbb !important;
      box-shadow: none;
      opacity: 1;
      scale: 1;
      translate: 0 0;
      transition: none;
      animation: none;
      cursor: default;
    }
    @media (prefers-reduced-motion: reduce) {
      ${arrow} {
        transition: none !important;
        animation: none !important;
        scale: 1 !important;
        translate: none !important;
      }
    }
  `;
  document.head.appendChild(style);
})();


/* State colours only: retain existing motion, dimensions and event handlers. */
(function () {
  'use strict';
  const style = document.createElement('style');
  style.id = 'sc-three-controls-state-colours';
  const quantity = ':is(#main, body) .product-form .quantity-selector--product > button.quantity-selector__button';
  const gallery = '.product-gallery .product-gallery__carousel-wrapper > button.sc-gallery-arrow';
  const viewer = '.sc-modern-viewer .pswp__prev-next > button.pswp__button';
  const enabled = ':not(:disabled):not([aria-disabled="true"])';
  style.textContent = `
    ${quantity} {
      background: #fff !important;
      color: var(--accent-color, #f47721) !important;
      box-shadow: inset 0 0 0 1px rgba(var(--accent-color-rgb, 244,119,33), .30);
    }
    ${gallery} {
      background: #fff !important;
      border-color: var(--accent-color, #f47721) !important;
      color: var(--accent-color, #f47721) !important;
    }
    ${viewer} { border-color: var(--accent-color, #f47721) !important; }
    ${quantity} svg, ${gallery} svg, ${viewer} svg {
      color: inherit !important;
    }
    @media (hover: hover) and (pointer: fine) {
      ${quantity}${enabled}:hover,
      ${gallery}${enabled}:hover,
      ${viewer}${enabled}:hover {
        background: var(--accent-color, #f47721) !important;
        color: #fff !important;
      }
    }
    ${quantity}${enabled}:active,
    ${gallery}${enabled}:active,
    ${viewer}${enabled}:active {
      background: var(--accent-color, #f47721) !important;
      color: #fff !important;
    }
    ${quantity}:disabled,
    ${quantity}[aria-disabled="true"] {
      background: #f3f3f3 !important;
      color: #999 !important;
      box-shadow: none !important;
      transform: none !important;
      transition: none !important;
      animation: none !important;
    }
  `;
  document.head.appendChild(style);
})();

/* Exact-variant card savings. Read-only presentation; never edits native prices. */
(function () {
  'use strict';
  const normalizeCardText = value => String(value).replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  function cardCandidate(payload, native, visibleText, now) {
    if (!payload || payload.schemaVersion !== 1 || payload.enabled !== true || payload.cardPriceVaries !== false) return null;
    if (payload.currency !== 'CAD' || payload.displayCurrency !== 'CAD' || !Array.isArray(payload.records)) return null;
    if (!native || typeof native.variantId !== 'string' || typeof native.sku !== 'string' || !native.sku) return null;
    const matches = payload.records.filter(record => record.variantId === native.variantId);
    if (matches.length !== 1) return null;
    const config = matches[0];
    if (config.sku !== native.sku || config.price !== native.price || config.reference !== native.reference) return null;
    if (config.verified !== true || config.currency !== 'CAD' || config.evidenceConfirmed !== true) return null;
    if (!Number.isSafeInteger(config.price) || !Number.isSafeInteger(config.reference) || config.price < 0 || config.reference <= config.price) return null;
    if (typeof BigInt !== 'function' || BigInt(config.price) * BigInt(10) < BigInt(config.reference) * BigInt(3)) return null;
    if (typeof config.sellingUnit !== 'string' || !config.sellingUnit.trim() || !Number.isSafeInteger(config.packQuantity) || config.packQuantity < 1) return null;
    if (!['supplier_compare_at', 'former_wholesale', 'msrp'].includes(config.referenceBasis)) return null;
    if (config.expiresAt != null && config.expiresAt !== '') {
      if (typeof config.expiresAt !== 'string' || !/T.*(?:Z|[+-]\d{2}:\d{2})$/.test(config.expiresAt)) return null;
      const expiry = Date.parse(config.expiresAt);
      if (!Number.isFinite(expiry) || now >= expiry) return null;
    }
    if (typeof config.priceText !== 'string' || !config.priceText || normalizeCardText(visibleText) !== normalizeCardText(config.priceText)) return null;
    if (typeof config.referenceText !== 'string' || !config.referenceText || typeof config.referenceLabel !== 'string' || !config.referenceLabel) return null;
    if (typeof config.saveText !== 'string' || !config.saveText.includes('__PERCENT__')) return null;
    return config;
  }
  // Autocomplete reuses this exact validator after resolving its own exact variant.
  window.scAutocompleteSavingsCandidate = cardCandidate;
  // SC_CARD_BROWSER_BOUNDARY
  const cardControllers = new WeakMap();
  function startCard(configNode) {
    if (cardControllers.has(configNode)) return;
    const card = configNode.closest('.product-item');
    if (!card) return;
    const initialJSON = configNode.textContent;
    let payload;
    try { payload = JSON.parse(initialJSON); } catch (_) { return; }
    const native = payload.cardVariant;
    let eventAllows = true;
    let expiryTimer = 0;
    let paintFrame = 0;
    const observer = new MutationObserver(paintCard);
    function observeCard() {
      observer.observe(card, {subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'href', 'checked', 'data-variant-url']});
    }
    function paintCard() {
      observer.disconnect();
      clearTimeout(expiryTimer);
      try {
        card.querySelectorAll('[data-sc-card-owned]').forEach(node => node.remove());
        if (!card.isConnected || !configNode.isConnected || configNode.textContent !== initialJSON || !eventAllows || !native) return;
        const list = card.querySelector('.product-item__price-list');
        if (!list) return;
        const checkedSwatches = Array.from(card.querySelectorAll('.color-swatch__radio:checked'));
        if (checkedSwatches.some(node => {
          try { return new URL(node.getAttribute('data-variant-url'), document.baseURI).searchParams.get('variant') !== native.variantId; }
          catch (_) { return true; }
        })) return;
        const title = card.querySelector('.product-item__title');
        if (title) {
          try {
            const linkedVariant = new URL(title.getAttribute('href'), document.baseURI).searchParams.get('variant');
            if (linkedVariant && linkedVariant !== native.variantId) return;
          } catch (_) { return; }
        }
        const visible = Array.from(list.querySelectorAll('.price:not(.price--compare)'))
          .filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
        if (visible.length !== 1) return;
        const clone = visible[0].cloneNode(true);
        clone.querySelectorAll('.visually-hidden').forEach(node => node.remove());
        const config = cardCandidate(payload, native, clone.textContent, Date.now());
        if (!config) return;
        const reference = document.createElement('del');
        reference.className = 'sc-card-verified-reference';
        reference.setAttribute('data-sc-card-owned', 'reference');
        reference.setAttribute('aria-label', config.referenceLabel + ': ' + config.referenceText);
        reference.textContent = config.referenceText;
        const saving = document.createElement('span');
        saving.className = 'sc-card-verified-saving';
        saving.setAttribute('data-sc-card-owned', 'saving');
        saving.textContent = config.saveText.replace('__PERCENT__', Math.round((config.reference - config.price) * 100 / config.reference) + '%');
        list.append(reference, saving);
        if (config.expiresAt) expiryTimer = setTimeout(paintCard, Math.min(Date.parse(config.expiresAt) - Date.now(), 2147483647));
      } finally {
        if (card.isConnected && configNode.isConnected) observeCard();
      }
    }
    function onChange() { paintCard(); }
    function onVariant(event) {
      const variant = event.detail && event.detail.variant;
      eventAllows = Boolean(variant && native && String(variant.id) === native.variantId && variant.sku === native.sku && variant.price === native.price && variant.compare_at_price === native.reference);
      paintCard();
    }
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
      cancelAnimationFrame(paintFrame);
      paintFrame = requestAnimationFrame(paintCard);
    }) : null;
    if (resize) resize.observe(card);
    card.addEventListener('change', onChange);
    card.addEventListener('variant:changed', onVariant);
    cardControllers.set(configNode, {stop() {
      observer.disconnect();
      if (resize) resize.disconnect();
      cancelAnimationFrame(paintFrame);
      clearTimeout(expiryTimer);
      card.removeEventListener('change', onChange);
      card.removeEventListener('variant:changed', onVariant);
    }});
    paintCard();
  }
  function visitCards(node) {
    if (node.nodeType !== 1) return;
    if (node.matches('script[data-sc-savings-card]')) startCard(node);
    node.querySelectorAll('script[data-sc-savings-card]').forEach(startCard);
  }
  visitCards(document.documentElement);
  new MutationObserver(records => records.forEach(record => {
    record.removedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      const removed = node.matches('script[data-sc-savings-card]') ? [node] : [];
      removed.push(...node.querySelectorAll('script[data-sc-savings-card]'));
      removed.forEach(config => {
        const controller = cardControllers.get(config);
        if (controller && !config.isConnected) { controller.stop(); cardControllers.delete(config); }
      });
    });
    record.addedNodes.forEach(visitCards);
  })).observe(document.documentElement, {subtree: true, childList: true});
})();

/* Desktop quantity pop: Web Animations surface; native quantity handlers retained. */
(function () {
  'use strict';
  if (window.scDesktopQuantitySurfaceInstalled) return;
  window.scDesktopQuantitySurfaceInstalled = true;
  const selector = '#main .product-block-list .product-form .quantity-selector--product > button.quantity-selector__button, body > .sc-sticky-purchase[data-initialized="true"] .sc-sticky-purchase__quantity > button[data-sc-quantity], #mini-cart .mini-cart__quantity .quantity-selector > button.quantity-selector__button';
  const desktop = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const changedProperties = ['position', 'isolation', 'z-index', 'overflow', 'background-color', 'color', 'box-shadow', 'transform', 'scale', 'translate', 'transition'];
  const curve = '180ms cubic-bezier(.16,1,.3,1)';
  const accent = 'var(--accent-color, #f47721)';
  const style = document.createElement('style');
  style.id = 'sc-js-quantity-surface-style';
  style.textContent = `
    button[data-sc-js-quantity-pop="true"]::before { content:none !important; display:none !important; }
    @media (min-width: 1000px) and (hover: hover) and (pointer: fine) {
      #mini-cart .mini-cart__quantity .quantity-selector { overflow: visible; }
      #mini-cart .mini-cart__quantity .quantity-selector > button[data-action="decrease-quantity"] { border-radius: 8px 0 0 8px; }
      #mini-cart .mini-cart__quantity .quantity-selector > button[data-action="increase-quantity"] { border-radius: 0 8px 8px 0; }
      #mini-cart .mini-cart__button-container button[name="checkout"]:not(:disabled):not([aria-disabled="true"]),
      #mini-cart .mini-cart__button-container a.button--secondary:not([aria-disabled="true"]) {
        position: relative;
        transition: transform 180ms cubic-bezier(.16,1,.3,1), box-shadow 180ms cubic-bezier(.16,1,.3,1), background-color 180ms cubic-bezier(.16,1,.3,1), border-color 180ms cubic-bezier(.16,1,.3,1), color 180ms cubic-bezier(.16,1,.3,1);
      }
      #mini-cart .mini-cart__button-container button[name="checkout"]:not(:disabled):not([aria-disabled="true"]):hover {
        z-index: 1;
        transform: translateY(-2px) scale(1.05);
        box-shadow: 0 5px 14px rgba(244,119,33,.20), 0 0 10px rgba(244,119,33,.10);
      }
      #mini-cart .mini-cart__button-container a.button--secondary:not([aria-disabled="true"]):hover {
        z-index: 1;
        background: rgba(244,119,33,.06);
        border-color: var(--accent-color, #f47721);
        color: #a94700;
        transform: translateY(-1px) scale(1.03);
        box-shadow: 0 3px 9px rgba(244,119,33,.12);
      }
      #mini-cart .mini-cart__button-container button[name="checkout"]:not(:disabled):not([aria-disabled="true"]):active,
      #mini-cart .mini-cart__button-container a.button--secondary:not([aria-disabled="true"]):active {
        transform: translateY(1px) scale(.97);
        box-shadow: 0 1px 4px rgba(244,119,33,.16);
      }
      #mini-cart a.mini-cart__quantity-remove[data-action="decrease-quantity"]:not([aria-disabled="true"]) {
        transition: color 180ms cubic-bezier(.16,1,.3,1), transform 180ms cubic-bezier(.16,1,.3,1);
      }
      #mini-cart a.mini-cart__quantity-remove[data-action="decrease-quantity"]:not([aria-disabled="true"]):hover {
        color: var(--accent-color, #f47721);
        text-decoration: underline;
        transform: translateY(-1px);
      }
      #mini-cart a.mini-cart__quantity-remove[data-action="decrease-quantity"]:not([aria-disabled="true"]):active { transform: scale(.99); }
      #mini-cart .mini-cart__quantity .quantity-selector > button.quantity-selector__button:focus-visible,
      #mini-cart .mini-cart__button-container button[name="checkout"]:focus-visible,
      #mini-cart .mini-cart__button-container a.button--secondary:focus-visible,
      #mini-cart a.mini-cart__quantity-remove:focus-visible { outline: 2px solid #a94700; outline-offset: 2px; }
      @media (prefers-reduced-motion: reduce) {
        #mini-cart .mini-cart__button-container button[name="checkout"]:not(:disabled):not([aria-disabled="true"]),
        #mini-cart .mini-cart__button-container button[name="checkout"]:not(:disabled):not([aria-disabled="true"]):hover,
        #mini-cart .mini-cart__button-container button[name="checkout"]:not(:disabled):not([aria-disabled="true"]):active,
        #mini-cart .mini-cart__button-container a.button--secondary:not([aria-disabled="true"]),
        #mini-cart .mini-cart__button-container a.button--secondary:not([aria-disabled="true"]):hover,
        #mini-cart .mini-cart__button-container a.button--secondary:not([aria-disabled="true"]):active,
        #mini-cart a.mini-cart__quantity-remove[data-action="decrease-quantity"]:not([aria-disabled="true"]),
        #mini-cart a.mini-cart__quantity-remove[data-action="decrease-quantity"]:not([aria-disabled="true"]):hover,
        #mini-cart a.mini-cart__quantity-remove[data-action="decrease-quantity"]:not([aria-disabled="true"]):active {
          transform: none !important; transition: none !important;
        }
      }
    }
  `;
  document.head.appendChild(style);
  const set = (element, property, value) => element.style.setProperty(property, value, 'important');
  const enabled = button => !button.disabled && button.getAttribute('aria-disabled') !== 'true';
  function restore(state) {
    if (state.animation) { state.animation.cancel(); state.animation = null; }
    state.motionKey = null;
    if (!state.original) return;
    changedProperties.forEach(property => {
      const previous = state.original[property];
      if (previous.value) state.button.style.setProperty(property, previous.value, previous.priority);
      else state.button.style.removeProperty(property);
    });
    state.button.removeAttribute('data-sc-js-quantity-pop');
    state.original = null;
  }
  function paint(state) {
    const button = state.button;
    const surface = state.surface;
    if (!desktop.matches || !enabled(button)) {
      restore(state);
      set(surface, 'display', 'none');
      state.pressed = false;
      return;
    }
    if (!state.original) {
      state.original = {};
      changedProperties.forEach(property => {
        state.original[property] = { value: button.style.getPropertyValue(property), priority: button.style.getPropertyPriority(property) };
      });
      button.setAttribute('data-sc-js-quantity-pop', 'true');
      set(button, 'position', 'relative');
      set(button, 'isolation', 'isolate');
      set(button, 'overflow', 'visible');
      set(button, 'background-color', 'transparent');
      set(button, 'box-shadow', 'none');
      set(button, 'transform', 'none');
      set(button, 'scale', '1');
      set(button, 'translate', 'none');
    }
    const highlighted = state.hovered || state.pressed;
    set(button, 'z-index', highlighted ? '2' : '0');
    set(button, 'color', highlighted ? '#fff' : accent);
    set(button, 'transition', reduced.matches ? 'none' : 'color ' + curve);
    set(surface, 'display', 'block');
    set(surface, 'transition', 'none');
    set(surface, 'background-color', highlighted ? accent : '#fff');
    const transform = reduced.matches ? 'none' : state.pressed ? 'translateY(1px) scale(.97)' : state.hovered ? 'translateY(-2px) scale(1.05)' : 'translateY(0) scale(1)';
    const glow = state.pressed ? ', 0 1px 4px rgba(244,119,33,.16)' : state.hovered ? ', 0 3px 10px rgba(244,119,33,.24)' : '';
    const shadow = 'inset 0 0 0 1px ' + (highlighted ? accent : 'rgba(244,119,33,.30)') + glow;
    const motionKey = String(reduced.matches) + ':' + transform + ':' + shadow;
    if (motionKey === state.motionKey) return;
    state.motionKey = motionKey;
    const current = getComputedStyle(surface);
    const from = { transform: current.transform, boxShadow: current.boxShadow };
    if (state.animation) { state.animation.cancel(); state.animation = null; }
    // These two properties must NOT be inline-important: that would override
    // Web Animations. All positioning and isolation safeguards stay important.
    surface.style.setProperty('transform', transform);
    surface.style.setProperty('box-shadow', shadow);
    if (!reduced.matches && typeof surface.animate === 'function') {
      const resolved = getComputedStyle(surface);
      const to = { transform: resolved.transform, boxShadow: resolved.boxShadow };
      const animation = surface.animate([from, to], {
        duration: 180, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'none'
      });
      state.animation = animation;
      animation.onfinish = () => { if (state.animation === animation) state.animation = null; };
    }
  }
  function attach(button) {
    if (states.has(button)) return;
    const surface = document.createElement('span');
    surface.setAttribute('aria-hidden', 'true');
    surface.setAttribute('data-sc-js-quantity-surface', '');
    ['position:absolute', 'inset:0', 'z-index:-1', 'pointer-events:none', 'border-radius:inherit', 'transform-origin:center', 'display:none'].forEach(declaration => {
      const split = declaration.indexOf(':');
      set(surface, declaration.slice(0, split), declaration.slice(split + 1));
    });
    const controller = new AbortController();
    const state = { button, surface, controller, original: null, hovered: button.matches(':hover'), pressed: false };
    states.set(button, state);
    button.appendChild(surface);
    const on = (name, handler) => button.addEventListener(name, handler, { passive: true, signal: controller.signal });
    on('pointerenter', () => { state.hovered = true; paint(state); });
    on('pointerleave', () => { state.hovered = false; state.pressed = false; paint(state); });
    on('pointerdown', event => {
      if (event.button !== 0 || !desktop.matches || !enabled(button)) return;
      state.pressed = true;
      paint(state);
    });
    on('keydown', event => {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      state.pressed = true;
      paint(state);
    });
    on('keyup', event => {
      if (event.key !== ' ' && event.key !== 'Enter') return;
      state.pressed = false;
      paint(state);
    });
    on('blur', () => { state.pressed = false; paint(state); });
    paint(state);
  }
  let queued = false;
  function scan() {
    queued = false;
    states.forEach((state, button) => {
      if (button.isConnected && button.matches(selector)) { paint(state); return; }
      restore(state);
      state.controller.abort();
      state.surface.remove();
      states.delete(button);
    });
    if (desktop.matches) document.querySelectorAll(selector).forEach(attach);
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }
  function release() {
    states.forEach(state => {
      if (!state.pressed) return;
      state.pressed = false;
      state.hovered = state.button.matches(':hover');
      paint(state);
    });
  }
  window.addEventListener('pointerup', release, { passive: true, capture: true });
  window.addEventListener('pointercancel', release, { passive: true, capture: true });
  window.addEventListener('blur', () => {
    states.forEach(state => { state.hovered = false; state.pressed = false; paint(state); });
  });
  desktop.addEventListener('change', schedule);
  reduced.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['disabled', 'aria-disabled', 'data-initialized']
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();

/* Verified savings: autocomplete only. Search and native prices stay in charge. */
(function () {
  'use strict';
  if (window.scAutocompleteSavingsStarted) return;
  window.scAutocompleteSavingsStarted = true;
  const ROOT = '.instant-search-menu.cloud-search-results';
  const ROW = ROOT + ' .block-products dd[data-id]';
  const OWNED = '[data-sc-autocomplete-owned]';
  const cache = new Map();
  const rows = new Map();
  const jobs = [];
  const flights = new Set();
  const TTL = 20000;
  let active = 0;
  let frame = 0;
  let expiryTimer = 0;
  let paused = false;
  const style = document.createElement('style');
  style.id = 'sc-autocomplete-verified-savings-style';
  style.textContent = `
    ${ROOT} .cs-price-block.sc-ac-price-row {
      display: flex !important; flex-wrap: wrap; align-items: baseline;
      justify-content: flex-end; gap: 4px 8px; max-width: 100%;
    }
    ${ROOT} .sc-ac-current {
      color: var(--accent-color, #f47721) !important; font-weight: 700 !important;
      text-decoration: none !important;
    }
    ${ROOT} .sc-ac-reference {
      color: #858585 !important; font-size: .9em; font-weight: 400;
      text-decoration: line-through !important; white-space: nowrap;
    }
    ${ROOT} .sc-ac-saving {
      color: var(--accent-color, #f47721) !important;
      border: 1px solid currentColor; border-radius: 5px;
      padding: 1px 5px; font-size: .78em; font-weight: 600;
      line-height: 1.4; white-space: nowrap;
    }
    .instant-search-menu .cloud-search-results--single-panel .cs-price-block.sc-ac-price-row {
      justify-content: flex-start;
    }
    ${ROOT} .block-products dd[data-id] .details-top-text.sc-ac-price-row {
      display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px 6px;
    }
    ${ROOT} .block-products dd[data-id] .details-top-text.sc-ac-price-row > .name,
    ${ROOT} .block-products dd[data-id] .details-top-text.sc-ac-price-row > .cs-sold-out {
      flex-basis: 100%;
    }
  `;
  document.head.appendChild(style);

  function visible(node) {
    if (!node || !node.isConnected || !node.getClientRects().length) return false;
    for (let current = node; current && current !== document.body; current = current.parentElement) {
      const css = getComputedStyle(current);
      if (current.hidden || current.getAttribute('aria-hidden') === 'true' ||
          css.display === 'none' || css.visibility === 'hidden' || css.opacity === '0') return false;
    }
    return true;
  }

  function identity(row) {
    const title = row.querySelector('.cs-product-link.cs-item-title');
    const link = title && (title.closest('a[href]') || row.querySelector('a.cs-product-link[href]'));
    const hoverBlock = row.matches('dd[data-id]') ? row.querySelector('.details-top-text') : null;
    const priceBlock = hoverBlock || row.querySelector('.cs-price-block');
    if (!title || !link || !row.contains(link) || !priceBlock) return null;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return null; }
    if (url.origin !== location.origin) return null;
    const path = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/([^/]+)\/?$/i);
    if (!path) return null;
    const ids = url.searchParams.getAll('variant');
    if (ids.length > 1 || (ids.length === 1 && !/^\d+$/.test(ids[0]))) return null;
    let handle;
    try { handle = decodeURIComponent(path[1]); } catch (_) { return null; }
    const sku = title.getAttribute('data-sku') || '';
    const variantId = ids[0] || '';
    const nativePrices = Array.from(priceBlock.querySelectorAll('.price:not(.cs-list-price)'))
      .filter(node => !node.matches(OWNED) && visible(node));
    if (nativePrices.length !== 1) return null;
    url.search = '';
    url.hash = '';
    url.searchParams.set('section_id', 'sc-autocomplete-savings');
    return {url: url.href, handle, sku, variantId, priceBlock, price: nativePrices[0], hoverPreview: !!hoverBlock};
  }

  function resolveVariant(metadata, key) {
    if (!metadata || metadata.handle !== key.handle || !Array.isArray(metadata.variants)) return null;
    const variants = metadata.variants;
    if (!Number.isSafeInteger(metadata.variantCount) || metadata.variantCount < variants.length) return null;
    let matches;
    if (key.variantId) {
      matches = variants.filter(variant => variant.variantId === key.variantId);
    } else if (key.sku) {
      // SKU-only resolution requires the complete variant list, not a capped subset.
      if (metadata.variantCount !== variants.length) return null;
      matches = variants.filter(variant => variant.sku === key.sku);
    } else {
      if (metadata.variantCount !== 1 || variants.length !== 1) return null;
      matches = variants;
    }
    if (matches.length !== 1) return null;
    const variant = matches[0];
    if (key.sku && variant.sku !== key.sku) return null;
    if (typeof variant.variantId !== 'string' || !/^\d+$/.test(variant.variantId)) return null;
    return variant;
  }

  function pump() {
    while (!paused && active < 2 && jobs.length) {
      const job = jobs.shift();
      flights.add(job);
      active++;
      fetch(job.url, {credentials: 'same-origin', cache: 'no-store', signal: job.controller.signal})
        .then(response => {
          if (!response.ok || response.redirected) throw new Error('Unavailable autocomplete data');
          return response.text();
        })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const root = doc.querySelector('[data-sc-autocomplete-data]');
          if (!root) return null;
          const metadata = root.querySelector('[data-sc-autocomplete-metadata]');
          const payload = root.querySelector('script[data-sc-savings-card]');
          if (!metadata || !payload) return null;
          return {metadata: JSON.parse(metadata.textContent), payload: JSON.parse(payload.textContent)};
        })
        .catch(() => null)
        .then(result => job.resolve(result))
        .finally(() => {
          clearTimeout(job.timeout);
          flights.delete(job);
          active--;
          pump();
        });
    }
  }

  function dataFor(url) {
    const existing = cache.get(url);
    if (existing && Date.now() - existing.created < TTL) return existing;
    if (existing) cache.delete(url);
    const entry = {created: Date.now(), settled: false, data: null};
    const controller = new AbortController();
    entry.promise = new Promise(resolve => {
      jobs.push({url, controller, resolve, timeout: setTimeout(() => controller.abort(), 8000)});
    }).then(data => {
      entry.settled = true;
      entry.data = data;
      schedule();
      return data;
    });
    cache.set(url, entry);
    while (cache.size > 40) cache.delete(cache.keys().next().value);
    pump();
    return entry;
  }

  function clearRow(row, state) {
    row.querySelectorAll(OWNED).forEach(node => node.remove());
    if (state && state.price) state.price.classList.remove('sc-ac-current');
    if (state && state.priceBlock) state.priceBlock.classList.remove('sc-ac-price-row');
  }

  function hoverCandidate(data, key, row) {
    const metadata = data && data.metadata;
    if (!metadata || metadata.handle !== key.handle || !Array.isArray(metadata.variants)) return null;
    if (!Number.isSafeInteger(metadata.variantCount) || metadata.variantCount < 1 ||
        metadata.variantCount !== metadata.variants.length) return null;
    if ((row.getAttribute('data-id') || '') !== metadata.productId) return null;
    const ids = metadata.variants.map(variant => variant.variantId);
    if (ids.some(id => typeof id !== 'string' || !/^\d+$/.test(id)) || new Set(ids).size !== ids.length) return null;
    if (key.variantId && !ids.includes(key.variantId)) return null;
    // XCloud's data-sku is a combined search index, NOT a selected variant SKU.
    // Prove the SAME comparison independently for EVERY actual product variant.
    const scoped = Object.assign({}, data.payload, {cardPriceVaries: false});
    const now = Date.now();
    const same = ['price', 'reference', 'currency', 'sellingUnit', 'packQuantity',
      'referenceBasis', 'priceText', 'referenceText', 'referenceLabel', 'saveText'];
    let common = null;
    let earliest = null;
    for (const variant of metadata.variants) {
      const config = window.scAutocompleteSavingsCandidate(scoped, variant, key.price.textContent, now);
      if (!config) return null;
      if (common && same.some(field => config[field] !== common[field])) return null;
      if (!common) common = config;
      if (config.expiresAt && (!earliest || Date.parse(config.expiresAt) < Date.parse(earliest))) {
        earliest = config.expiresAt;
      }
    }
    return common ? Object.assign({}, common, {expiresAt: earliest}) : null;
  }

  function candidate(data, key, row) {
    if (!data || typeof window.scAutocompleteSavingsCandidate !== 'function') return null;
    if (key.hoverPreview === true) return hoverCandidate(data, key, row);
    const variant = resolveVariant(data.metadata, key);
    if (!variant) return null;
    const rowId = row.getAttribute('data-id') || '';
    if (/^\d+$/.test(rowId) && rowId !== data.metadata.productId && rowId !== variant.variantId) return null;
    // This row now represents ONE exact variant. A range cannot match its priceText.
    // The original card validator and every record/currency/expiry/70% guard are reused.
    const scoped = Object.assign({}, data.payload, {cardPriceVaries: false});
    return window.scAutocompleteSavingsCandidate(scoped, variant, key.price.textContent, Date.now());
  }

  function paint(row, key, config) {
    const reference = document.createElement('del');
    reference.className = 'sc-ac-reference';
    reference.setAttribute('data-sc-autocomplete-owned', 'reference');
    reference.setAttribute('aria-label', config.referenceLabel + ' ' + config.referenceText);
    reference.textContent = config.referenceText;
    const saving = document.createElement('span');
    saving.className = 'sc-ac-saving';
    saving.setAttribute('data-sc-autocomplete-owned', 'saving');
    const percentage = Math.round((config.reference - config.price) * 100 / config.reference);
    saving.textContent = config.saveText.replace('__PERCENT__', String(percentage) + '%');
    key.price.before(reference);
    key.priceBlock.appendChild(saving);
    key.price.classList.add('sc-ac-current');
    key.priceBlock.classList.add('sc-ac-price-row');
    rows.set(row, {price: key.price, priceBlock: key.priceBlock});
  }

  function scan() {
    frame = 0;
    if (paused) return;
    observer.disconnect();
    clearTimeout(expiryTimer);
    let nextExpiry = Infinity;
    try {
      for (const [row, state] of rows) clearRow(row, state);
      rows.clear();
      const openRows = Array.from(document.querySelectorAll(ROW))
        .filter(visible).map(row => ({row, key: identity(row)})).filter(item => item.key);
      const wanted = new Set(openRows.map(item => item.key.url));
      for (let index = jobs.length - 1; index >= 0; index--) {
        const job = jobs[index];
        if (!wanted.has(job.url)) {
          jobs.splice(index, 1);
          clearTimeout(job.timeout);
          job.controller.abort();
          cache.delete(job.url);
          job.resolve(null);
        }
      }
      openRows.forEach(({row, key}) => {
        const entry = dataFor(key.url);
        if (!entry.settled || !entry.data) return;
        const config = candidate(entry.data, key, row);
        if (!config) return;
        paint(row, key, config);
        if (config.expiresAt) nextExpiry = Math.min(nextExpiry, Date.parse(config.expiresAt));
      });
    } finally {
      observe();
    }
    // Refresh open suggestions against fresh server context, without delaying search.
    if (rows.size) {
      const refreshIn = Math.min(TTL, nextExpiry - Date.now());
      expiryTimer = setTimeout(schedule, Math.max(25, refreshIn));
    }
  }

  function schedule() {
    if (!paused && !frame) frame = requestAnimationFrame(scan);
  }

  function relevant(mutation) {
    const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
    if (target && (target.matches('.instant-search-menu') || target.closest(ROOT))) return true;
    return [...mutation.addedNodes, ...mutation.removedNodes].some(node => node.nodeType === 1 &&
      (node.matches('.instant-search-menu, .cloud-search-results') || node.querySelector('.instant-search-menu, .cloud-search-results')));
  }

  const observer = new MutationObserver(mutations => {
    if (mutations.some(relevant)) schedule();
  });
  function observe() {
    observer.observe(document.body, {childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'href', 'data-sku']});
  }
  window.addEventListener('pagehide', () => {
    paused = true;
    observer.disconnect();
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    clearTimeout(expiryTimer);
    for (const [row, state] of rows) clearRow(row, state);
    rows.clear();
    flights.forEach(job => job.controller.abort());
    jobs.splice(0).forEach(job => {
      clearTimeout(job.timeout);
      job.controller.abort();
      job.resolve(null);
    });
    cache.clear();
  });
  window.addEventListener('pageshow', () => { paused = false; observe(); schedule(); });
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('focus', schedule);
  observe();
  schedule();
})();

/* Fresh legacy login: native POST return_to, never a page-load redirect. */
(function () {
  'use strict';
  if (window.scNativeLoginReturnInstalled) return;
  window.scNativeLoginReturnInstalled = true;
  const returnKeys = ['return_to', 'return_url'];
  const checkoutKeys = ['checkout_url', 'checkout', 'checkout_id', 'checkout_token'];
  function hasValue(values, keys) {
    return keys.some(key => values.getAll(key).some(value => typeof value === 'string' && value.trim()));
  }
  function checkoutPath(path) {
    return /\/(?:checkout|checkouts|cart)(?:\/|$)/i.test(path);
  }
  function localReturn(value, base) {
    try {
      const target = new URL(value, base.href);
      if (target.origin !== base.origin || !/^https?:$/.test(target.protocol)) return null;
      if (/\/account\/(?:login|logout)(?:\/|$)/i.test(target.pathname)) return null;
      return target.pathname + target.search + target.hash;
    } catch (_) { return null; }
  }
  function selectReturn(values, page, action, referrer, defaultTarget) {
    // Existing successful form fields always win, including app-provided intent.
    if (hasValue(values, returnKeys.concat(checkoutKeys))) return null;
    const contexts = [action, page];
    if (contexts.some(url => hasValue(url.searchParams, checkoutKeys))) return null;
    for (const url of contexts) {
      for (const key of returnKeys) {
        const value = url.searchParams.get(key);
        if (value && value.trim()) return localReturn(value, page);
      }
    }
    if (checkoutPath(page.pathname) || checkoutPath(action.pathname)) return null;
    if (referrer && /\/account\/login\/?$/.test(page.pathname)) {
      try { if (checkoutPath(new URL(referrer).pathname)) return null; } catch (_) {}
    }
    return localReturn(defaultTarget, page);
  }
  function whatsNewTarget() {
    // Prefer the actual existing navigation link, retaining its locale/query.
    const links = document.querySelectorAll('#meteor-desktop-nav > li > a[href], .nav-bar__linklist > li > a[href]');
    for (const link of links) {
      try {
        const target = new URL(link.href, location.href);
        if (target.origin === location.origin && /\/collections\/new\/?$/.test(target.pathname)) {
          return target.pathname + target.search + target.hash;
        }
      } catch (_) {}
    }
    // Existing live New collection, confirmed against its saved handle.
    return '/collections/new';
  }
  document.addEventListener('formdata', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !['header_customer_login', 'customer_login'].includes(form.id)) return;
    if (String(form.method).toLowerCase() !== 'post' || event.formData.get('form_type') !== 'customer_login') return;
    try {
      const page = new URL(location.href);
      const action = new URL(form.action, page.href);
      if (action.origin !== page.origin || !/\/account\/login\/?$/.test(action.pathname)) return;
      const target = selectReturn(event.formData, page, action, document.referrer, whatsNewTarget());
      if (target) event.formData.set('return_to', target);
    } catch (_) {
      // On an unrecognised context, leave the original authentication untouched.
    }
  }, true);
})();
